import { RootStoreModel } from "@redux/reducers";
import { Layout, Menu } from "antd";
import dayjs from 'dayjs';
import { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  SwitchMenu
} from "../../redux/actions";
import Store from "../../redux/store";
import { gaEvent } from "../../withTracker";
import { RouteModal } from "./routes";
import "./sider.scss";

import { useTranslation } from "react-i18next";

const { Sider } = Layout;
const { SubMenu } = Menu;
const updateTime = dayjs().subtract(1, "day").format("YYYY-MM-DD");

export function SiteSider() {
  const [collapsed, setCollapsed] = useState(false);
  const [selectKey, setSelectKey] = useState("");
  const [currentMenu, setCurrentMenu] = useState("");
  let history = useHistory();
  let location = useLocation();

  const { t } = useTranslation();

  const user = useSelector((state: RootStoreModel) => state.userState);
  const getMenuRouteBychildModules=(module:any)=>{

    let routeModal:RouteModal ={
        title: module.name,
        key:module.key,
        path: module.url
      }
    // let routeModal:RouteModal = TotalRoutes.filter(c=>c.key == module.key)[0];
    // if(!routeModal){
    //   routeModal={
    //     title: module.name,
    //     key:module.key,
    //     path: module.url
    //   }
    // }else{
    //   routeModal.title = module.name;
    // }
    
    if(module?.childModules && module?.childModules.length>0){
      let subPaths:RouteModal[]=[];
      module?.childModules.forEach((child:any) => {
        let childRouteModal:RouteModal =getMenuRouteBychildModules(child);
        subPaths.push(childRouteModal);
      });
      routeModal.path =module.key;
      routeModal.subPaths = subPaths;
    }
    return routeModal;
  
  }

  let results: RouteModal[] = []
  if(!user.account.isInitialPassword)
  {
    let temResults : RouteModal[] = []
    let accountRoutes = user.account.modules;
    if(accountRoutes){
      let selectRoutes = accountRoutes.filter((c:any)=>c.key == user.menuKey)[0]?.childModules
      selectRoutes?.forEach((item:any) => {
        let tem = getMenuRouteBychildModules(item);
        temResults.push(tem);
      });
    }
    results = temResults;
  }

  const clickMenuItem = (item: any) => {
    console.log("clickMenuItem",item)
    const path = item.key;
    setSelectKey(item.key)
    history.push(path);
    
  };
  const goHelp = () => {
    history.push("/home/help");
    Store.dispatch(SwitchMenu("help"));
  };
  
  const renderItems = (route: RouteModal) => {
    const { title, icon, subPaths ,path} = route;
    if (subPaths && subPaths.length > 0) {
      return (
        <SubMenu icon={icon} key={path} title={t(title)}>
          {subPaths.map((item) => renderItems(item))}
        </SubMenu>
      );
    } else {
      return (
        <Menu.Item key={path}>
          <span>{t(title)}</span>
        </Menu.Item>
      );
    }
  };
  const getOpenKeys = ()=>{
    let keys:string[] = results.map(c=>c.path??"");
    //console.log("getOpenKeys",keys)
    return keys;
  }
  const getSelecttKeys = ()=>{
    //console.log("getSelecttKeys",user.menuKey,currentMenu,selectKey)
    if(selectKey!="" && currentMenu == user.menuKey){
      return [selectKey]
    }else{
      setCurrentMenu(user.menuKey)
      let defaultFirst = getMenuFirst(results[0])
      if(defaultFirst){
        let keys:string[] =[defaultFirst.path]
        //console.log("getSelecttKeys-2",defaultFirst,keys)
        setSelectKey(defaultFirst.path);
        return keys;
      }else{
        //console.log("getSelecttKeys-空")
        return []
      }
    }
  }
  const getMenuFirst:any=(menuRoute:any)=>{
    if(menuRoute?.subPaths && menuRoute?.subPaths.length>0){
      return getMenuFirst(menuRoute?.subPaths[0])
    }else{
      return menuRoute;
    }
  }
  return (
    <Sider
      className="homeSider"
      breakpoint="lg"
      width="230"

      collapsed={collapsed}
      onCollapse={() => { setCollapsed(!collapsed); gaEvent("heander", "onClick", "setCollapsed") }}
    >
      <div style={{minHeight:"96%",overflow:"auto"}}>
        
        {results && results.length>0 && (
        <Menu
          mode="inline"
          theme="light"
          className="homeMenu"
           selectedKeys={getSelecttKeys()}
           openKeys={getOpenKeys()}
          onClick={(e) => { clickMenuItem(e); gaEvent("heander", "onClick", "clickMenuItem") }}
        >
          {results.map(({ title, icon, path, subPaths }) => {
            if (subPaths && subPaths?.length) {
              return (
                <SubMenu icon={icon} key={path} title={t(title)}>
                  {subPaths.map((item) => renderItems(item))}
                </SubMenu>
              );
            } else {
              return (
                <Menu.Item key={path} title="">
                  <div title={collapsed ? t(title) : ""}>
                    {icon}
                    <span>{t(title)}</span>
                  </div>
                </Menu.Item>
              );
            }
          })}
        </Menu>
        ) }
      </div>
      
      {/* <a onClick={()=>{goHelp()}} className="helpBom"  style={{padding: 5}}>{t("Help Support")}</a> */}
    </Sider>
  );
}

// export default SiteHeader;
